import { Component } from "react"

/* Moment */
import moment from "moment"

/* Helpers */
import { utils } from "../../helpers"

/* Shared */
import { metric, number } from "./shared"


/* Widget Reviews Tab — what the clients wrote about the point */
class ReviewsTab extends Component {

    render = () => {

        /* Fields */
        const { data } = this.props
        const { reviews, statistics } = data

        const rating = number(statistics.reviews.rating)

        return (
            <div className="organization-details-body">

                <div className="organization-details-metrics">
                    {metric("Рейтинг", rating > 0 ? `${rating.toFixed(1)} ★` : "Нет оценок")}
                    {metric("Всего отзывов", number(statistics.reviews.total))}
                    {metric("С ответом", number(statistics.reviews.replied), "green")}
                </div>

                <div className="organization-details-section">

                    <div className="organization-details-section-text">Последние отзывы</div>

                    {reviews.length === 0 && <div className="organization-details-empty">Отзывов пока нет</div>}

                    {reviews.map(review =>
                        <div key={`${review.id}`} className="organization-details-review">

                            <div className="organization-details-review-head">
                                <div className="organization-details-review-user">{utils.check(review.user, "Клиент")}</div>
                                <div className="organization-details-review-rate">{"★".repeat(parseInt(review.rate))}</div>
                                <div className="organization-details-review-date">{moment(review.createdAt).format("DD.MM.YYYY")}</div>
                            </div>

                            {review.comment && <div className="organization-details-review-text">{review.comment}</div>}

                            {review.reply &&
                                <div className="organization-details-review-reply">
                                    <span>Ответ заведения</span>
                                    {review.reply}
                                </div>
                            }

                        </div>
                    )}

                </div>

            </div>
        )
    }
}

export default ReviewsTab
